'use strict'
DoohApps
    .directive('deviceImage', ['$filter', function ($filter) {
        return {
            restrict: 'A',
            scope: {
                url: '@deviceImage'
            },
            link: function (scope, elem) {
                scope.$watch('url', function () {
                    elem.css({
                        'background-image': ('url(' + $filter('HttpRemove')(
                            typeof (scope.url) != 'undefined' && scope.url != null && scope.url != ''
                                ? scope.url
                                : 'Content/doohapps_screen.png') + ')')
                    });
                });
            }
        };
        
    }]);